<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/zonas/regiones`;
const paisesUrl = `${process.env.VUE_APP_API_URL}/api/zonas/options/paises`;
const token = utilsService.getToken();

const regionService = {
  async getAll(pais) {
    try {
      let url = apiUrl;
      if (pais !== undefined && pais !== null && pais !== '') {
        url = `${apiUrl}?pais=${encodeURIComponent(pais)}`;
      }
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async get(id) {
    try {
      const response = await axios.get(`${apiUrl}/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      window.location.href = '/error';
    }
  },

  async getPaisesOptions() {
    try {
      const response = await axios.get(paisesUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async create(formRaw) {
    try {
      const body = {
        nombre: formRaw.nombre,
        numero: (formRaw.numero === '' || formRaw.numero === null || typeof formRaw.numero === 'undefined')
          ? null
          : Number(formRaw.numero),
        idPais: formRaw.idPais,
      };

      const response = await axios.post(apiUrl, body, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response;
    } catch (error) {
      // No envolver el error con new Error(...): si viene de Axios, re-lanzar
      // tal cual para conservar response.status y response.data.
      if (error && error.response) {
        throw error;
      }
      throw {
        response: {
          status: 0,
          data: (error && error.message) ? error.message : 'Error en la solicitud.',
        },
      };
    }
  },

  async update(formRaw, id) {
    try {
      const body = {
        nombre: formRaw.nombre,
        numero: (formRaw.numero === '' || formRaw.numero === null || typeof formRaw.numero === 'undefined')
          ? null
          : Number(formRaw.numero),
        idPais: formRaw.idPais,
      };

      const response = await axios.put(`${apiUrl}/${id}`, body, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data || 'Error al actualizar la región.');
      } else {
        throw new Error(error.message || 'Error en la solicitud.');
      }
    }
  },

  async deleteBy(id) {
    try {
      const response = await axios.delete(`${apiUrl}/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },
};

export default regionService;
</script>
